export default __webpack_public_path__ + "static/media/Group.776d9a58.png";